import React from "react";
import { bool, node, string } from "prop-types";
import { classes } from "../utils/classes";
import { spacingClassName, spacingProps, spacingPropTypes } from "../props/spacing";

const ImageCaption = ({
	isBlock = false,
	caption = "",
	spacing = { ...spacingProps },
	className = "",
	children,
}) => {
	const Tag = isBlock ? "div" : "span";
	const captionText = caption;
	return (
		<Tag
			className={classes(
				"image-caption",
				isBlock && "image-caption--block",
				...spacingClassName(spacing),
				className,
			)}
		>
			{children}
			{captionText && <span className="image-caption__text">{captionText}</span>}
		</Tag>
	);
};

ImageCaption.propTypes = {
	isBlock: bool,
	className: string,
	caption: node,
	spacing: spacingPropTypes,
	children: node.isRequired,
};

export default ImageCaption;
